// import LikeButton from '@allesauto/core/likeButton';
import NextImage from '@allesauto/core/nextImage';
import Price from '@allesauto/core/price';
import { ViewModes } from '@allesauto/utils/consts';
import type { AccessoriesProduct } from '@allesauto/utils/types.d';
import { ArrowRight20 } from '@carbon/icons-react';
import clsx from 'clsx';
import React, { FC, useCallback } from 'react';

export interface AccessoriesCatalogItemProps {
  product: AccessoriesProduct;
  onClick?: (productId: string) => void;
}

const AccessoriesCatalogItem: FC<
  React.PropsWithChildren<AccessoriesCatalogItemProps>
> = ({ product, onClick }) => {
  const handleClickEvent = useCallback(() => {
    if (onClick) {
      onClick(product.productId);
    }
  }, [onClick, product]);

  const className = {
    container: clsx(
      'bg-transparent cursor-pointer flex flex-col group px-25px py-40px relative w-full md:px-30px hover:bg-grey10',
      "after:absolute after:bg-green60 after:bottom-0 after:content-[''] after:duration-[400ms] after:ease-linear after:h-0 after:left-0 after:overflow-hidden after:transition-[height] after:w-full hover:after:h-7px",
      'wl-bg-highlight-after monochrome:after:bg-black'
    ),
    favWrapper: 'text-right',
    title:
      'break-words h-full mb-20px md:mb-30px font-headline text-purple80 line-clamp overflow-hidden text-ellipsis text-headline4 monochrome:text-black',
    imageContainer: 'h-full mb-15px bg-white relative',
    image: 'block pt-[62.5%] relative pointer-events-none',
    imageShadow:
      'group-hover:shadow-[inset_0_0_3.6rem_rgba(0,0,0,0.08)] absolute w-full h-full top-0 left-0',
    bottomRow:
      'flex items-center justify-between text-purple80 monochrome:text-black',
    price: '!text-headline4',
    arrowRight: 'opacity-0 group-hover:opacity-100',
  };

  return (
    <div onClick={handleClickEvent} className={className.container}>
      {/* Commented for feature implementation of Favorite
      <div className={className.favWrapper}>
        <LikeButton onClick={() => null} isActive={false} />
      </div> */}
      <div className={className.imageContainer}>
        <div className={className.image}>
          <NextImage
            baseUrls=""
            unoptimized
            alt={product.title}
            src={product.galleryThumbnail}
            layout="fill"
            objectFit="contain"
            priority={true}
          />
        </div>
        <div className={className.imageShadow}></div>
      </div>
      <h4 className={className.title}>{product.title}</h4>
      <div className={className.bottomRow}>
        <Price
          priceTextKey="ui.PRICE.PRICE_ONLY"
          price={product.price}
          displayView={ViewModes.GRID}
          classNames={{
            mainPriceClass: className.price,
          }}
        />

        <ArrowRight20 className={className.arrowRight} />
      </div>
    </div>
  );
};

export default AccessoriesCatalogItem;
